module.exports = __webpack_public_path__ + "static/media/anatomia2.07ca1bce.png";